import { createFileRoute } from "@tanstack/react-router";
import { Installation, EditContent } from "@/features/consent-solutions";

const Route = createFileRoute("/_authorized/consent-solutions/$csId/installation/")({
  component: () => (
    <EditContent>
      <Installation />
    </EditContent>
  ),
});

export { Route };
